import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import MeasureDimensionComponent from '../components/measure-dimension.component';
import { measureDimensions } from '../../../../../../redux/measure-dimensions/action';
import { selectMeasureDimensionsQueryItems } from '../../../../../../redux/measure-dimensions/selector';

const ManagementMeasureDimension = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const measureDimensionsQuery = useSelector(selectMeasureDimensionsQueryItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)

  const [
    selectMeasureDimensions,
    setSelectMeasureDimensions
  ] = useState<any>([])

  const fetchDeliveryDatesQueryById= ()=>{
    dispatch(measureDimensions.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-dimensions/query`,entity:'measureDimensions',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectMeasureDimensions({ ...selectMeasureDimensions, [field]: event })
  }

  useEffect(
    () => {
            if (parmas?.id > 0) {
                fetchDeliveryDatesQueryById()
                setIsLoading(false)
                } else{
                    setIsLoading(false) 
                }
         
       
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectMeasureDimensions(measureDimensionsQuery?.result?.items)
    }
    },
    [isQuery]
  ) 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
      if (parmas?.id > 0) {
     dispatch(measureDimensions.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-dimensions`,entity:'measureDimensions',jsonData:{
          
    Records: [
        selectMeasureDimensions
    ]
 
}})) .then(()=>{
    back()
  })
      }else{
        dispatch(measureDimensions.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-dimensions`,entity:'measureDimensions',jsonData:{
            
        Records: [
            selectMeasureDimensions
        ]
      
    }})).then(()=>{
        back()
      })
      }
  }
 
const back=()=>{
  navigate('/management/configuration/shipment/measures')
} 

    return (
        <>

        {isLoading ? <PageLoader /> : 
          <MeasureDimensionComponent 
          handleInnerFormChange={handleInnerbasicFormChange}
          selectMeasureDimensions={selectMeasureDimensions}
          back={back}
          handleFormSubmit={handleFormSubmit}
          /> 
    } 
          </>
    )
    
    }
   
    export default ManagementMeasureDimension;